/**
 * Drag-and-Drop Type Definitions
 *
 * Separated from component files to enable Fast Refresh.
 */

import type { ToolDefinition } from '../../stores/toolStore';
import type { Group } from '../../stores/timelineStore';

/**
 * DnD item types for type safety
 */
export const DND_ITEM_TYPES = {
  SIDEBAR_TOOL: 'SIDEBAR_TOOL',
  TIMELINE_TOOL: 'TIMELINE_TOOL',
  TOOL_GROUP: 'TOOL_GROUP',
  /** Placed group on timeline being dragged for repositioning */
  PLACED_GROUP: 'PLACED_GROUP',
} as const;

/**
 * Data structure for dragging sidebar tools
 */
export interface SidebarToolDragItem {
  type: typeof DND_ITEM_TYPES.SIDEBAR_TOOL;
  toolDefinition: ToolDefinition;
}

/**
 * Data structure for dragging tool groups from sidebar
 * Groups are placed as atomic units on the timeline
 */
export interface GroupDragItem {
  type: typeof DND_ITEM_TYPES.TOOL_GROUP;
  groupId: string;
  group: Group;
}

/**
 * Data structure for dragging placed groups on timeline for repositioning
 */
export interface PlacedGroupDragItem {
  type: typeof DND_ITEM_TYPES.PLACED_GROUP;
  placedGroupId: string;
  originalTrackNumber: number;
  originalStartTime: number;
  /**
   * Offset in pixels from the left edge of the group where the user grabbed it.
   * Used to preserve the grab point when dropping.
   */
  grabOffsetX: number;
}
